import { ResponsiveContainer } from '@arpeggi/ui'
import { Box, Spacer } from '../../core/Components'
import { Flex } from '../../core/Flex'
import ProfileCard from '../../platform/dashboard/ProfileCard'
import Title from '../new-explore/components/Title'

export const Navbar = () => (
  <ResponsiveContainer>
    <Flex
      css={{
        paddingTop: '$32',
        paddingBottom: '$16',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '8px',
        '@mobile': {
          flexDirection: 'row',
          gap: 0
        }
      }}
    >
      <Title>Welcome to Arpeggi Labs</Title>
      <Spacer />
      <Box css={{ width: '200px', '@mobile': { width: 'inherit' } }}>
        <ProfileCard />
      </Box>
    </Flex>
  </ResponsiveContainer>
)
